const PropTypes = require('prop-types');
const React = require('react');
const ProductBundle = require('./product_bundle.jsx');
const UrlHelpers = require('components/shared/url_helpers.js');
const { Tracker } = require('@reverbdotcom/discovery-ui');

const BUNDLE_VIEWED_EVENT = 'product_bundle';
const UPSELL_VIEWED_EVENT = 'upsell_bundle';

class Promo extends React.Component {
  constructor() {
    super();
    this.state = { productBundle: { bundled_products: [] } };
  }

  componentDidMount() {
    this.fetchProductBundle();
  }

  fetchProductBundle() {
    Reverb.APIRequest.get(UrlHelpers.productBundlePath(this.props.productId))
      .done((response) => {
        if (!response) { return; } // we return a 204 in some scenarios, for which we get no response object
        this.setState({ productBundle: response });
        if (response.id) {
          this.trackEvent(response, BUNDLE_VIEWED_EVENT);
        } else if (response.bundled_products) {
          this.trackEvent(response, UPSELL_VIEWED_EVENT);
        }
      });
  }

  trackEvent(bundle, eventType) {
    Tracker.view({
      name: eventType,
      type: 'listings',
      ids: bundle.bundled_products.map(l => l.id),
    });
  }

  get bundledProducts() {
    if (!this.state.productBundle.bundled_products) {
      return [];
    }
    return this.state.productBundle.bundled_products;
  }

  render() {
    if (!this.bundledProducts.length) { return false; }

    return (
      <div className="module bd-rounded mb-2">
        <ProductBundle
          productBundle={this.state.productBundle}
        />
      </div>
    );
  }
}

Promo.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

module.exports = Promo;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/promo.jsx